import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Close from '../../assets/svgs/Close';
import ErrorNotification from '../../assets/svgs/ErrorNotification';
import SuccessNotification from '../../assets/svgs/SuccessNotification';
import WarningNotification from '../../assets/svgs/WarningNotification';
import { hideNotification } from '../../actions/Notification/notificationActions';

const NotificationItem = ({ className, type, id, children }) => {
    const [isClosed, setClose] = useState(false);
    const dispatch = useDispatch();

    const close = notificationID => {
        setClose(true);
        setTimeout(() => {
            dispatch(hideNotification(notificationID));
        }, 300);
    };

    useEffect(() => {
        setTimeout(() => {
            close(id);
        }, 7000);
    }, []);

    const renderTitle = notificationType => {
        switch (notificationType) {
            case 'success':
                return 'تبریک!';
            case 'error':
                return 'خطایی رخ داد!';
            case 'warning':
                return 'هشدار!';
            default:
                return '!تبریک';
        }
    };

    const renderIcon = notificationType => {
        switch (notificationType) {
            case 'success':
                return <SuccessNotification />;
            case 'error':
                return <ErrorNotification />;
            case 'warning':
                return <WarningNotification />;
            default:
                return <SuccessNotification />;
        }
    };

    return (
        <div className={`${className} ${isClosed ? 'hide-notification' : ''}`}>
            <div className="NotificationItem__Icon">{renderIcon(type)}</div>
            <div className="NotificationItem__Content">
                <span>{renderTitle(type)}</span>
                <p>{children}</p>
                <Close onClick={() => close(id)} />
            </div>
        </div>
    );
};

NotificationItem.propTypes = {
    className: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    children: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
};

export default styled(NotificationItem)`
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    max-width: 310px;
    height: 53px;
    border-radius: 9px;
    border: 3px solid #fafafa;
    margin-top: 10px;
    overflow: hidden;
    transition: all 300ms ease-out;

    &.hide-notification {
        opacity: 0;
    }

    .NotificationItem__Icon {
        display: flex;
        align-items: center;

        svg {
            margin-right: ${({ type }) =>
                type === 'warning' ? '7px' : '10px'};
        }
    }

    .NotificationItem__Content {
        display: flex;
        flex-flow: column wrap;
        justify-content: center;
        position: relative;
        background-color: #e8ebff;
        flex: 0 0 237px;

        > span,
        > p {
            position: relative;
            margin-right: -7px;
        }

        > span {
            ${({ type }) => {
                switch (type) {
                    case 'success':
                        return 'color: #00BE77;';
                    case 'error':
                        return 'color: #fe5f55;';
                    case 'warning':
                        return 'color: #B88F04;';
                    default:
                        return 'color: #00BE77;';
                }
            }}
            font-size: 14px;
            font-weight: bold;
        }

        > p {
            color: #7e7e7e;
            font-size: 12px;
            font-weight: 300;
            line-height: 21px;
        }

        > svg {
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
        }

        &:before {
            content: '';
            position: absolute;
            right: 0px;
            top: 0;
            width: 25px;
            height: 100%;
            background-color: inherit;
            border-radius: 0% 100% 100% 0% / 100% 0% 100% 0%;
            transform: translateX(100%);
            box-shadow: 4px 1px 1px 1px #fff;
        }
    }

    .NotificationItem__Icon {
        height: 50px;
        flex: 0 0 67px;
        ${({ type }) => {
            switch (type) {
                case 'success':
                    return 'background-color: #00BE77;';
                case 'error':
                    return 'background-color: #FE5F55;';
                case 'warning':
                    return 'background-color: #FED755;';
                default:
                    return 'background-color: #00BE77;';
            }
        }}
    }
`;
